import { Grid } from "@mui/material";
import PerformanceDashboardOverallScoreTrend from "./PerformanceDashboardOverallScoreTrend";
import PerformanceDashboardOverallScoreGraph from "./PerformanceDashboardOverallScoreGraph";

interface PerformanceDashboardOverallScoreProps {
  OverallScore: any;
  AverageOverallScore: any;
}

const PerformanceDashboardOverallScore = ({
  OverallScore,
  AverageOverallScore,
}: PerformanceDashboardOverallScoreProps) => {
  return (
    <>
      <Grid container spacing={3} mb={2} className="overallScoreWrap">
        <Grid item xs={6}>
          <PerformanceDashboardOverallScoreGraph
            OverallScore={OverallScore}
            AverageOverallScore={AverageOverallScore}
          />
        </Grid>
        <Grid item xs={6}>
          <PerformanceDashboardOverallScoreTrend />
        </Grid>
      </Grid>
    </>
  );
};

export default PerformanceDashboardOverallScore;
